import { render, staticRenderFns } from "./AcknowledgeList.vue?vue&type=template&id=2c2400aa&"
import script from "./AcknowledgeList.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports